{
  "close": "Sulje"
}
